import { secondAxios } from "../../../../../../../../api/axios";

export const ifDrawingUrl = async ({
  drawingId,
  selectedDrawings,
  setSelectedDrawings,
}) => {
  const res = await secondAxios.get("drawing/" + drawingId);
  const drawing = res?.data;

  setSelectedDrawings([
    ...selectedDrawings,
    { ...drawing, materials: drawing?.materials },
  ]);
};
